import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import ImageCropUpload from 'vue-image-crop-upload';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, default_1, [].concat(args));
    _defineProperty(_this, "value", void 0);
    _defineProperty(_this, "field", void 0);
    _defineProperty(_this, "width", void 0);
    _defineProperty(_this, "height", void 0);
    _defineProperty(_this, "params", void 0);
    _defineProperty(_this, "headers", void 0);
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "show",
    get: function get() {
      return this.value;
    },
    set: function set(value) {
      this.$emit('input', value);
    }
  }, {
    key: "language",
    get: function get() {
      return AppModule.language;
    }
  }, {
    key: "srcFileSet",
    value: function srcFileSet(fileName, fileType, fileSize) {
      this.$emit('src-file-set', fileName, fileType, fileSize);
    }
  }, {
    key: "cropSuccess",
    value: function cropSuccess(imgDataUrl, field) {
      this.$emit('crop-success', imgDataUrl, field);
    }
  }, {
    key: "cropUploadSuccess",
    value: function cropUploadSuccess(jsonData, field) {
      this.$emit('crop-upload-success', jsonData, field);
    }
  }, {
    key: "cropUploadFail",
    value: function cropUploadFail(status, field) {
      this.$emit('crop-upload-fail', status, field);
    }
  }]);
}(Vue);
__decorate([Prop({
  required: true
})], default_1.prototype, "value", void 0);
__decorate([Prop({
  required: true
})], default_1.prototype, "field", void 0);
__decorate([Prop({
  default: 300
})], default_1.prototype, "width", void 0);
__decorate([Prop({
  default: 300
})], default_1.prototype, "height", void 0);
__decorate([Prop({
  default: function _default() {}
})], default_1.prototype, "params", void 0);
__decorate([Prop({
  default: function _default() {}
})], default_1.prototype, "headers", void 0);
default_1 = __decorate([Component({
  name: 'ImageUpload',
  components: {
    ImageCropUpload: ImageCropUpload
  }
})], default_1);
export default default_1;